import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/gold-onboard-image.svg'


const _withScopeId = n => (_pushScopeId("data-v-1936cdff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-bottom-gold-onboard-section" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-1936cdff><div class=\"modal-header-bg\" data-v-1936cdff></div><img class=\"modal-header-image\" src=\"" + _imports_0 + "\" data-v-1936cdff></div><div class=\"modal-body\" data-v-1936cdff><span class=\"modal-body-title\" data-v-1936cdff><span class=\"title-line\" data-v-1936cdff>ยินดีด้วย!</span> คุณได้รับสิทธิเป็นมายโลตัส โกลด์</span><span class=\"modal-body-description\" data-v-1936cdff>พบกับสิทธิพิเศษเหนือระดับมากมาย</span><span class=\"modal-body-description\" data-v-1936cdff>สะสมยอดช้อปต่อเนื่องเพื่อรักษาสถานะ</span></div>", 2)
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          disabled: _ctx.isUpgrading,
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.upgradeCustomerTier()))
        }, "อัปเกรดทันที!", 8, _hoisted_6),
        _createElementVNode("button", {
          class: "btn btn-link",
          disabled: _ctx.isUpgrading,
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.closeModal()))
        }, "ไว้ทีหลัง", 8, _hoisted_7)
      ])
    ])
  ]))
}